import { useEffect } from 'react';
import { connect } from 'react-redux';
import { array, bool, func, object } from 'prop-types';
import { withRouter } from 'react-router-dom';

import { loadSdkContent } from '../../redux/reducers/ghost';
import { HtmlParser } from '../../elements';
import docs from '../docs/Docs.module.scss';

const mapStateToProps = (state) => ({
  sdkPages: state.ghost.sdkPages,
  sdkPost: state.ghost.sdkPost,
  sdkPagesLoaded: state.ghost.sdkPagesLoaded,
  location: state.router.location,
});
const mapDispatchToProps = {
  loadSdkContent,
};

Sdk.propTypes = {
  sdkPost: object,
  sdkPages: array,
  loadSdkContent: func,
  sdkPagesLoaded: bool,
};

function Sdk(props) {
  const { sdkPost, location, sdkPages, loadSdkContent, history, sdkPagesLoaded } = props;

  useEffect(() => {
    //need to reload content when page reloads
    if (sdkPagesLoaded && !!sdkPages.length) {
      const url = location.pathname.split('/');
      const slug = url[url.length - 1];

      let isInvalidUrl = true;
      sdkPages.forEach((page) => {
        if (page.slug === slug) {
          loadSdkContent({ id: page.id, type: 'pages', sdkPageId: slug, sdkPostId: '' });
          isInvalidUrl = false;
        }

        if (!!page.posts.length) {
          page.posts.forEach((post) => {
            const pageSlug = url[url.length - 2] || '';
            const originalSlug = page.slug + '/' + slug;
            const currentSlug = pageSlug + '/' + post.slug;

            if (originalSlug === currentSlug) {
              loadSdkContent({ id: post.id, type: 'posts', sdkPageId: url[url.length - 2], sdkPostId: slug });
              isInvalidUrl = false;
            }
          });
        }
      });

      if (isInvalidUrl) {
        history.replace({
          state: { detail: 'wrong url request' },
        });
      }
    }
  }, [location, sdkPagesLoaded]);

  return (
    <div className={docs.docs}>
      <h1>{sdkPost.title || ''}</h1>
      {typeof sdkPost.content === 'string' && <HtmlParser content={sdkPost.content} />}
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Sdk));
